<template>
  <div>
    <div class="d-block d-sm-block d-md-none">
      <NavbarPayment></NavbarPayment>
    </div>

    <div class="row">
      <div :class="`col-lg-7 ${col_md} col-sm-12 col-xs-12 pt-0`">
        <div class="container-payment">

          <!--solo escritorios-->
          <div class="d-none d-sm-none d-md-block">
            <NavbarPayment></NavbarPayment>
          </div>

          <v-breadcrumbs :items="items">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>

          <div v-show="!is_auth && step == 'information_shipping'" class="row mb-100">
            <div class="col mb-100">
              <div class="d-flex justify-content-end font-general-r">
                <p class="color-blue font-weight-bold mr-5">¿Ya tienes una cuenta?</p>
                <router-link
                  v-if="$route.query.c && $route.query.ttems"
                  class="a-login"
                  :to="{
                    path: '/iniciar-sesion',
                    query: { ref: 'tienda', c: $route.query.c, ttems: $route.query.ttems }
                  }"
                >
                  Iniciar sesión
                </router-link>
                <router-link
                  v-else
                  class="a-login"
                  :to="{ path: '/iniciar-sesion', query: { ref: 'tienda' }}"
                >
                  Iniciar sesión
                </router-link>
              </div>
              <FormRegisterAddress
                :address="address"
                :show_input_email="true"
                :new_address="true"
                :valid_address="valid_address"
                @validateLocation="validateNewLocation"
                @changeStep="changeStep"
              />
            </div>
          </div>

          <div class="mt-50" style="padding-bottom: 100px">

            <!--esto sale cuando se esta logueado para elegir una direccion o crear una nueva-->
            <div class="row" v-show="step == 'information_shipping' && is_auth">
              <div class="col">
                <div class="text-center">
                  <p class="color-blue h4 font-general-r mt-2 mb-5">DIRECCIÓN DE ENVÍO</p>

                  <div v-if="user_address.length">

                    <!--inputs radio para seleccionar opcion de direcciones-->
                    <div class="flex-center mb-5">
                      <v-radio-group
                        v-model="new_address"
                        row
                      >
                        <v-radio
                          label="Dirección existente"
                          :value="false"
                        ></v-radio>
                        <v-radio
                          label="Nueva dirección"
                          :value="true"
                        ></v-radio>
                      </v-radio-group>
                    </div>

                    <!--dropdown para seleccionar direccion-->
                    <v-menu v-if="!new_address" offset-y v-show="!new_address">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          color="accent"
                          v-bind="attrs"
                          v-on="on"
                          class="mt-2"
                        >
                          {{ address_selected ? address_selected.full_address : 'ELIGE UNA DIRECCIÓN'}}
                          <v-icon color="primary">mdi-menu-swap</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in user_address"
                          :key="index"
                          @click="validateAddressExists(item)"
                        >
                          <v-list-item-title>{{ item.full_address }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <FormRegisterAddress
                      v-if="address_selected && !new_address"
                      :address="address_selected"
                      :show_input_email="false"
                      :new_address="false"
                      :valid_address="valid_address"
                      @validateLocation="validateNewLocation"
                      @changeStep="changeStep"
                    />

                  </div>

                  <div v-show="new_address">
                    <FormRegisterAddress
                      :address="address"
                      :show_input_email="false"
                      :new_address="new_address"
                      :valid_address="valid_address"
                      @validateLocation="validateNewLocation"
                      @changeStep="changeStep"
                    />
                  </div>
                </div>

              </div>
            </div>

            <ShippingData
              v-show="step == 'shipping_data'"
              :address="address"
              :address_selected="address_selected"
              :new_address="new_address"
              :price_delivery="price_delivery"
              :loading="loading_calc_delivery"
              :disabled_button="disabled_button_next_payment"
              @changeStep="changeStep"
              @calculatedPriceDelivery="changeDeliveryType"
            />

            <div v-show="step == 'payment_data'">

              <div class="row">
                <div class="col">

                  <!--contacto-->
                  <div class="mb-1 div-border-payment p-1">
                    <div class="d-flex align-items-center justify-content-between flex-wrap font-general-r">
                      <span class="ml-2 color-blue">Contacto</span>
                      <span class="color-primary">
                        {{ is_auth ? user.email : address.contact_email }}
                      </span>
                      <v-btn
                        small
                        v-if="!is_auth"
                        class="nv-btn-small font-weight-bold"
                        text
                        elevation="0"
                        color="accent"
                        @click="changeStep('information_shipping', 1)"
                      >
                        Cambiar
                      </v-btn>
                    </div>
                  </div>

                  <!--enviar a-->
                  <div v-if="delivery_type != 'free'" class="mb-1 div-border-payment p-1 font-general-r">
                    <div class="d-flex align-items-center justify-content-between flex-wrap">
                      <span class="ml-2 color-blue">Enviar a</span>
                      <span v-if="new_address" class="color-primary">
                        {{ address.city }}
                        {{ address.colony }}
                        {{ address.street }}
                        {{ address.no_outside }}
                        {{ address.no_inside }}
                      </span>
                      <span v-if="!new_address && address_selected" class="color-primary">
                        {{ address_selected.city }}
                        {{ address_selected.colony }}
                        {{ address_selected.street }}
                        {{ 'Ext. '+address_selected.no_outside }}
                        {{ 'Int. '+address_selected.no_inside }}
                      </span>
                      <v-btn small @click="step = 'information_shipping'" class="nv-btn-small font-weight-bold" text elevation="0" color="accent">
                        Cambiar
                      </v-btn>
                    </div>
                  </div>

                  <!--metodo-->
                  <div class="div-border-payment p-1">
                    <div class="d-flex align-items-center justify-content-between flex-wrap font-general-r">
                      <span class="ml-2 color-blue">Método</span>
                      <span class="color-primary">
                        {{ delivery_type == 'free' ? 'Recoger en tienda - Gratis' : `CDMX - ${currencyFormat(this.price_delivery)}` }}
                      </span>
                      <v-btn small @click="step = 'shipping_data'" class="nv-btn-small font-weight-bold" text elevation="0" color="accent">
                        Cambiar
                      </v-btn>
                    </div>
                  </div>

                </div>
              </div>

              <div class="row">
                <div class="col">
                  <!--pago con tarjeta-->
                  <div class="mb-2 div-border-payment pa-sm-4">
                    <div class="d-flex p-1 align-items-center justify-content-between flex-wrap font-general-r">
                      <v-radio-group v-model="payment_type" style="margin: 0;">
                        <v-radio
                          color="accent"
                          class="ml-2"
                          value="stripe"
                        >
                          <template v-slot:label>
                            <strong class="accent--text">TARJETA DE DÉBITO O CRÉDITO</strong>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </div>
                    <div class="p-2 bg-payment-data" v-show="payment_type == 'stripe'">
                      <div class="row">
                        <div class="col">
                          <div ref="card_number" class="input-nv input-nv-padding"></div>
                          <!--<input placeholder="Número de tarjeta" v-model="card.number" name="card" v-validate="'required'" data-vv-as="Número de tarjeta" class="input-nv" id="card">
                          <br>
                          <span v-show="errors.has('card')" class="text-danger mt-2">
                            {{ errors.first("card") }}
                          </span>-->
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <input v-model="card.name" placeholder="Nombre del titular" name="name_card" v-validate="'required'" data-vv-as="Nombre del titular" class="input-nv" id="card">
                          <br>
                          <span v-show="errors.has('name_card')" class="text-danger mt-2">
                            {{ errors.first("name_card") }}
                          </span>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <div ref="card_expiry" class="input-nv input-nv-padding"></div>
                        </div>
                        <div class="col">
                          <div ref="card_cvc" class="input-nv input-nv-padding"></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--PAYPAL-->
                  <div class="mb-2 div-border-payment">
                    <div class="d-flex p-1 align-items-center justify-content-between flex-wrap font-general-r">
                      <v-radio-group v-model="payment_type" style="margin: 0;">
                        <v-radio color="accent" class="ml-2" value="paypal">
                          <template v-slot:label>
                            <img class="brand-paypal" src="@/assets/store/paypal_blue.png" alt="">
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </div>
                  </div>

                  <!--MERCADO PAGO-->
                  <!-- <div class="div-border-payment">
                    <v-overlay
                      :absolute="true"
                      :value="loading_mp"
                    >
                      <v-progress-circular
                        indeterminate
                        size="20"
                      ></v-progress-circular>
                    </v-overlay>
                    <div class="d-flex p-1 align-items-center justify-content-between flex-wrap font-general-r">
                      <v-radio-group v-model="payment_type" style="margin: 0;">
                        <v-radio color="accent" class="ml-2" value="mp">
                          <template v-slot:label>
                            <img class="brand-mp" src="@/assets/store/mp.png" alt="">
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </div>
                  </div> -->

                </div>
              </div>

              <div class="row">
                <div class="col">
                  <textarea
                    rows="2"
                    v-model="comments"
                    class="mt-2 input-nv"
                    placeholder="Peticiones especiales"
                    maxlength="50"
                    @keyup="validateLengthComments"
                    @onfocus="setCommentsMercadoPago"
                    style="
                      font-size: 18px !important;
                      font-weight: 500 !important;
                      max-width: 500px;
                      text-align: left !important;
                    "
                  ></textarea>
                </div>
              </div>

              <div class="row">
                <div class="col text-left">
                  <v-btn
                    text
                    color="primary"
                    @click="back('shipping_data', 2)"
                  >
                    <v-icon left>
                      mdi-arrow-left
                    </v-icon>
                    Volver a información de envío
                  </v-btn>
                </div>
              </div>
              <div class="row">
                <div class="col text-right">
                  <div v-show="payment_type == 'paypal'" id="paypal-button"></div>
                  <div id="button-mp" v-show="payment_type == 'mp'">

                  </div>
                  <v-btn
                    v-if="payment_type == 'stripe'"
                    @click="payment()"
                    color="primary"
                    class="nv-btn nv-btn-large nv-btn-hover"
                    elevation="0"
                    :loading="loading_btn_stripe"
                  >
                    FINALIZAR EL PEDIDO
                  </v-btn>
                </div>
              </div>

            </div>

          </div>

          <FooterPayment class="d-none d-sm-none d-md-block"></FooterPayment>
        </div>
      </div>

      <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 d-none d-sm-none d-md-block" style="padding: 0 !important">
        <div class="container-cart-payment">
          <CartPayment
            :shipping_price="price_delivery"
            :step_payment="step"
            @appliedDiscount="appliedDiscount"
          ></CartPayment>
        </div>
      </div>
    </div>

    <v-overlay :value="overlay">
      <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
    </v-overlay>

    <v-snackbar
      v-model="open_message"
      color="accent"
      dark
    >
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="open_message = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog
      v-model="success_payment"
      persistent
      max-width="890"
    >
      <v-card class="pa-2">
        <v-card-text>

          <div class="d-flex justify-content-center align-items-center mt-10 color-blue font-general-r">
            <img style="width: 15%; max-width: 150px; max-height: 150px" class="mr-10 d-none d-sm-none d-md-block" src="@/assets/store/iconos/bolsa.svg" alt="">
            <div class="text-center">
              <h3>Gracias!</h3>
              <h5>Tu compra ha sido procesada exitosamente</h5>
              <h5>Te llegará un email con los detalles de entrega</h5>
              <span class="h5">Esperamos que vuelvas pronto</span>
            </div>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            elevation="0"
            class="nv-btn nv-btn-medium"
            @click="() => $router.push('/')"
          >
            ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script src="https://js.stripe.com/v3/"></script>

<script>
import { currencyFormat } from '../helpers'
import { mapGetters, mapState } from 'vuex'
//import SubscriptionService from '@/services/subscription.service'
import GeneralService from '@/services/general.service'
import UserService from '@/services/user.service'
import PaymentService from '@/services/payment.service'
import isPointInPolygon from 'geolib/es/isPointInPolygon';
import convertDistance from 'geolib/es/convertDistance'

import ShippingData from '@/components/store/ShippingData'
import FormRegisterAddress from '@/components/store/FormRegisterAddress'
import CartPayment from '@/components/store/CartPayment'
import NavbarPayment from '@/components/store/NavbarPayment'
import FooterPayment from '@/components/store/FooterPayment'
import moment from 'moment'

let stripe = Stripe(process.env.VUE_APP_STRIPE_KEY)

let style = {
  base: {
    iconColor: '#14365b',
    color: '#14365b',
    fontSize: '20px',
    fontFamily: 'Kanit',
    textAlign: 'center',
    fontWeight: 'bold',

    '::placeholder': {
      color: '#14365b'
    }
  }
}

export default {
  components: {
    FormRegisterAddress,
    ShippingData,
    CartPayment,
    NavbarPayment,
    FooterPayment
  },
  data() {
    return {
      loading_calc_delivery: false,
      now: moment().format('YYYY-MM-DD'),
      col_md: 'col-md-7',
      comments: '',
      discount_id_applied: false,
      button_mp_generated: false,
      route_payment_paypal: 'quick-payment-paypal',
      success_payment: false,
      payment_type: '',
      delivery_type: 'free',
      open_message: false,
      message: '',
      overlay: false,
      step: 'information_shipping',
      loading: false,
      address: {
        contact_email: '',
        name: '',
        lastname: '',
        street: '',
        no_outside: '',
        no_inside: '',
        colony: '',
        zip: '',
        city: '',
        phone: '',
        primary_address: false,
        latitude: '',
        longitude: '',
        save_info: false,
        full_address: ''
      },
      card: {
        number: '',
        name: '',
        month: '',
        year: '',
        cvc: ''
      },
      items: [
        { text: 'Mi compra', disabled: false, href: '' },
        { text: 'Información', disabled: true, href: '' },
        { text: 'Envíos', disabled: true, href: '' },
        { text: 'Pago', disabled: true, href: '' },
      ],
      user_address: [],
      new_address: false,
      address_selected: null,
      valid_address: true,
      coords_restricted: [],
      price_delivery: 0,
      loading_btn_stripe: false,

      price_by_km_extra: 5,

      loading_mp: false,

      lalamove_quotation: [],
      disabled_button_next_payment: false
    }
  },
  watch: {
    step(newval) {
      this.$store.state.step_payment_order = newval
      if (newval == 'shipping_data' && this.delivery_type == 'cdmx') {
        this.calculatedPriceDelivery()
      }
    },
    address_selected(newval) {
      this.address = newval
    },
    payment_type(newval) {
      if (newval == 'mp') {
        this.generateCheckoutMercadoPago()
      }
    },
    new_address(newval) {
      this.address = JSON.parse(JSON.stringify(this.$options.data().address))
    }
  },
  computed: {
    ...mapState(['campaign_order', 'is_auth', 'user', 'cart', 'cart_total', 'select_discount']),
    ...mapGetters(['total_cart'])
  },
  methods: {
    setCommentsMercadoPago() {
      localStorage.setItem(
        'order_temporal',
        JSON.stringify({
          cart: this.cart.cart_products,
          total: this.total_cart,
          shipping_total: this.price_delivery,
          payment_type: 'mp',
          delivery_type: this.delivery_type,
          address: this.address,
          new_address: this.new_address,
          comments: this.comments
        })
      )
    },
    validateLengthComments() {
      if (this.comments.length > 50) {
        this.comments = this.comments.substr(0, 50)
      }
    },
    changeDeliveryType(type) {
      this.delivery_type = type
      if (type == 'cdmx') {
        this.calculatedPriceDelivery()
      } else {
        this.disabled_button_next_payment = false
        this.price_delivery = 0
      }
    },
    validateNewLocation(data) {
      this.address = JSON.parse(JSON.stringify(this.$options.data().address))
      this.address = data.address
      this.validateLocation(data.lat, data.lng)
    },
    async generateCheckoutMercadoPago() {
      this.loading_mp = true

      let data_send = {
        cart: this.cart.cart_products,
        shipping_total: this.price_delivery,
        delivery_type: this.delivery_type,
        discount_id: this.discount_id_applied || this.select_discount ? this.select_discount.id : false,
        host_redirect: window.location.origin
      }

      if (this.campaign_order) {
        data_send.campaign_order = this.campaign_order
        data_send.date_view_dcn = localStorage.getItem('view_dcn')
      }

      const { data:res } = await PaymentService.generateCheckoutMercadoPago(data_send)
      if (res.success) {

        this.button_mp_generated = true

        let button_mp = document.getElementById('button-mp').firstChild

        if (!button_mp) {
          let mp = document.createElement('script')
          mp.setAttribute('src', 'https://www.mercadopago.com.mx/integrations/v1/web-payment-checkout.js')
          mp.setAttribute('data-preference-id', res.data)
          let button = document.getElementById('button-mp')
          button.appendChild(mp)
        } else {
          button_mp.parentNode.removeChild(button_mp);
          let btn = document.getElementById('button-mp').lastChild
          btn.parentNode.removeChild(btn);
          let mp = document.createElement('script')
          mp.setAttribute('src', 'https://www.mercadopago.com.mx/integrations/v1/web-payment-checkout.js')
          mp.setAttribute('data-preference-id', res.data)
          let button = document.getElementById('button-mp')
          button.appendChild(mp)
        }

        localStorage.setItem(
          'order_temporal',
          JSON.stringify({
            cart: this.cart.cart_products,
            total: this.total_cart,
            shipping_total: this.price_delivery,
            payment_type: 'mp',
            delivery_type: this.delivery_type,
            address: this.address,
            new_address: this.new_address,
            comments: this.comments,
            // quotation: this.lalamove_quotation
          })
        )
      } else {
        this.payment_type = ''
        this.$swal(res.error, '', 'warning')
      }
      this.loading_mp = false
    },
    async calculatedPriceDeliveryOld() {
      try {

        this.disabled_button_next_payment = true
        this.loading_calc_delivery = true

        const destination = {
          address: this.address
        }

        const { data:res } = await PaymentService.calculatedPriceDelivery(
          destination
        )
        if (!res.data.clientError) {
          this.price_delivery = parseFloat(res.data.response.totalFee)
          this.lalamove_quotation = res.data.quotation
          this.disabled_button_next_payment = false
        } else {
          this.$swal(res.data.messageError, '', 'warning')
        }
        this.loading_calc_delivery = false
        this.$store.dispatch('setDeliveryPriceGlobal', this.price_delivery)
      } catch (error) {
        this.loading_calc_delivery = false
        this.$swal('Ha ocurrido un error interno, intenta de nuevo', '', 'warning')
      }
    },
    calculatedPriceDelivery() {

      let origin = new google.maps.LatLng(19.4090857, -99.1770353);
      let destination = new google.maps.LatLng(
        parseFloat(this.address.latitude),
        parseFloat(this.address.longitude)
      )

      let service = new google.maps.DistanceMatrixService();
      service.getDistanceMatrix(
        {
          origins: [origin],
          destinations: [destination],
          travelMode: 'DRIVING'
        }, (response, status) => {
          if (response.rows[0].elements[0].status == 'ZERO_RESULTS') {
            this.$swal(
              'Parece que la dirección ingresada no es correcta',
              'Por favor vuelve a ingresar tu dirección y intentalo nuevamente'
            )
            return false
          }

          //distancia entre los dos puntos en metros
          let distance_meters = response.rows[0].elements[0].distance.value

          //convierto la distancia en km
          let distance_km = convertDistance(distance_meters, 'km')

          distance_km = Math.round(
            parseFloat(distance_km)
          )

          const km_init = 5
          if (distance_km > km_init) {
            const km_exceded = distance_km - km_init
            let delivery = (km_exceded * this.price_by_km_extra) + 40
            delivery = delivery.toFixed(2)
            this.price_delivery = parseFloat(delivery)
          } else {
            this.price_delivery = 40
          }
          this.$store.dispatch('setDeliveryPriceGlobal', this.price_delivery)
        });

    },
    generateStripe() {
      let elements = stripe.elements({
        fonts: [
          {
            cssSrc: 'https://fonts.googleapis.com/css2?family=Kanit&display=swap'
          }
        ]
      })
      let cardNumberElement = elements.create('cardNumber', {
        style: style,
        placeholder: 'Número de tarjeta'
      });
      cardNumberElement.mount(this.$refs.card_number);
      this.cardNumberElement = cardNumberElement

      let cardExpiryElement = elements.create('cardExpiry', {
        style: style,
        placeholder: 'MM/AA'
      });
      cardExpiryElement.mount(this.$refs.card_expiry);

      let cardCvcElement = elements.create('cardCvc', {
        style: style,
        placeholder: 'CVC'
      });
      cardCvcElement.mount(this.$refs.card_cvc);
    },
    payment() {
      if (this.payment_type == 'stripe') {
        this.paymentWithStripe()
      }
    },
    async paymentWithStripe() {
      this.loading_btn_stripe = true

      try {
        let data_send = {
          cart: this.cart.cart_products,
          total: this.total_cart,
          shipping_total: this.price_delivery,
          payment_type: 'stripe',
          delivery_type: this.delivery_type,
          address: this.address,
          paymentID: '',
          new_address: this.new_address,
          discount_id: this.discount_id_applied || this.select_discount ? this.select_discount.id : false,
          comments: this.comments,
          // quotation: this.lalamove_quotation
        }

        if (this.campaign_order) {
          data_send.campaign_order = this.campaign_order
          data_send.date_view_dcn = localStorage.getItem('view_dcn')
        }

        const { paymentMethod, error } = await stripe.createPaymentMethod(
            'card', this.cardNumberElement, {
            billing_details: { name: this.card.name }
          }
        );
        data_send.paymentID = paymentMethod.id
        if (error) {
          this.$swal(error.message, '', 'warning')
        } else {
          try {
            let route = 'payment-stripe'
            if (!this.is_auth) route = 'quick-payment-stripe'
            const { data:res } = await PaymentService.paymentStripe(
              data_send,
              route
            )
            if (res.success) {
              this.$store.dispatch('cleanCart')
              localStorage.removeItem('campaign_order')
              this.$store.dispatch('setPackageOrder', null)

              if (this.campaign_order && this.campaign_order.date == this.now) {
                this.$router.push('/confirmacion-compra?dcn=s')
              } else {
                this.$router.push('/confirmacion-compra')
                //this.success_payment = true
              }
            } else {
              if (res.hasOwnProperty('error_code')) this.payment_type = ''
              this.$swal(
                res.message,
                'Si el problema persiste, intenta recargar el sitio web e intentar de nuevo el proceso',
                'warning'
              )
            }
            this.loading_btn_stripe = false
          } catch (error) {
            this.loading_btn_stripe = false
            this.$swal(
              'No se pudo procesar tu pago, intentalo de nuevo',
              'Si el problema persiste, intenta recargar el sitio web e intentar de nuevo el proceso',
              'warning'
            )
          }
        }
      } catch (error) {
        this.loading_btn_stripe = false
      }
    },
    validateAddressExists(address) {
      this.address_selected = address
      this.address = address
      //this.validateLocation(this.address_selected.latitude, this.address_selected.longitude)
    },
    goShipping() {
      if (!this.address.latitude || !this.address.longitude || !this.valid_address) {
        this.message = 'La dirección seleccionada no es válida'
        this.open_message = true
        return false
      }
      if (!this.new_address) {
        if (!this.address_selected) {
          this.message = 'Debes seleccionar una dirección'
          this.open_message = true
          return false
        } else {
          this.changeStep('shipping_data', 1)
        }
      } else {
        this.$validator.validateAll('form-address').then(async result => {
          if (!result) {
            this.message = 'Debes registrar una dirección'
            this.open_message = true
            return false
          } else {
            this.changeStep('shipping_data', 1)
          }
        })
      }
    },
    changeStep(step, index) {
      this.step = step
      this.items[index].disabled = false
      window.scrollTo(0, 0)

      let go = ''
      if (step == 'information_shipping') go = 'direccion-envio'
      if (step == 'shipping_data') go = 'tipo-entrega'
      if (step == 'payment_data') go = 'pago'

      this.$router.replace({path: '/procesar-pago', query: {step: go}})
    },
    back(step, index) {
      if (step == 'shipping_data') {
        this.payment_type = ''
      }
      this.step = step
      this.items[index].disabled = true
      let go = ''
      if (step == 'information_shipping') go = 'direccion-envio'
      if (step == 'shipping_data') go = 'tipo-entrega'
      if (step == 'payment_data') go = 'pago'

      this.$router.replace({path: '/procesar-pago', query: {step: go}})
    },
    async getUserAddress() {
      this.overlay = true
      const { data:res } = await UserService.getUserAddress()
      this.user_address = res
      if (!res.length) {
        this.new_address = true
      }
      this.overlay = false
    },
    /*
    validateLocation(lat, lng) {
      this.loading = true
      for (let index = 0; index < this.coords_restricted.length; index++) {
        if (isPointInPolygon({
          latitude: lat,
          longitude: lng
        }, this.coords_restricted[index])) {
          this.valid_address = false
          break
        } else {
          this.valid_address = true
        }
      }
      setTimeout(() => {
        this.loading = false
        if (!this.valid_address) {
          this.$swal('Lo sentimos, no estamos disponibles para la ubicación seleccionada', '', 'warning')
        }
      }, 1000)
    },*/
    /*async getCoordsRestricted() {
      const { data:res } = await GeneralService.getCoordsRestricted()
      res.coords_denied.forEach(i => {
        this.coords_restricted.push([])
        i.forEach(j => {
          this.coords_restricted[this.coords_restricted.length - 1].push({
            latitude: j[0],
            longitude: j[1]
          })
        })
      })
    },*/
    currencyFormat(price) {
			return currencyFormat(price)
    },
    appliedDiscount(data) {
      this.discount_id_applied = data.dis.id
      if (data.type == 'shipping_free') {
        this.price_delivery = 0
      }
      if (this.payment_type == 'mp') {
        this.generateCheckoutMercadoPago()
      }
    },
    /*async getPriceDelivery() {
			const { data:res } = await GeneralService.getPriceDelivery()
			this.price_by_km_extra = parseFloat(res.price_km_delivery)
		}*/
  },
  mounted() {
    let width = screen.width
    if (width < 960 || width >= 768) {
      this.col_md = 'col-md-12'
    }

    //this.getPriceDelivery()
    //this.getCoordsRestricted()

    setTimeout(() => {
      this.generateStripe()
      if (this.is_auth) {
        this.address.name = this.user.name
        this.address.lastname = this.user.lastname
        this.getUserAddress()
        this.route_payment_paypal = 'payment-paypal'
      } else {
        this.new_address = true
      }
    }, 1500)

    paypal.Button.render({
      env: process.env.VUE_APP_ENVIRONMENT, //sandbox or production
      client: {
        //sandbox: process.env.VUE_APP_PAYPAL_ID,
        production: process.env.VUE_APP_PAYPAL_ID
      },
      style: {
        color:'blue',
        shape:'rect',
        height: 40
      },
      locale: 'en_MX',
      payment: (data, actions) => {
        return actions.request.post(`${process.env.VUE_APP_URL_API}create-payment-paypal`, {
          description: `Compra tienda online nieve de olla`,
          amount: this.total_cart,
          shipping: this.price_delivery,
          currency: 'MXN',
          delivery_type: this.delivery_type,
          discount_id: this.discount_id_applied || this.select_discount ? this.select_discount.id : false,
          // quotation: this.lalamove_quotation
        }).then(res => {
          if (res.hasOwnProperty('success') && !res.success) {
            this.$swal(
              res.title,
              res.message || '',
              "warning"
            );
            this.payment_type = ''
          } else {
            return res.id;
          }
        }).catch(err => {
          this.$swal(
            "Estamos teniendo problemas al procesar el pago con PayPal",
            "Intenta más tarde",
            "warning"
          )
        })
      },
      // Execute the payment:
      // 1. Add an onAuthorize callback
      onAuthorize: (data, actions) => {
        return actions.request.post(`${process.env.VUE_APP_URL_API}exec-payment-paypal`, {
          paymentID: data.paymentID,
          payerID:   data.payerID
        }).then(async res => {
          this.loading = true
          const payment_method_id = res.transactions[0].related_resources[0].sale.id
          let status = res.state

          let data_order = {
            cart: this.cart.cart_products,
            total: this.total_cart,
            shipping_total: this.price_delivery,
            payment_type: 'paypal',
            delivery_type: this.delivery_type,
            address: this.address,
            paymentID: payment_method_id,
            new_address: this.new_address,
            status: status,
            discount_id: this.discount_id_applied || this.select_discount ? this.select_discount.id : false,
            comments: this.comments,
            // quotation: this.lalamove_quotation
          }

          if (this.campaign_order) {
            data_order.campaign_order = this.campaign_order
            data_order.date_view_dcn = localStorage.getItem('view_dcn')
          }

          const { data:response } = await PaymentService.paymentPaypal(data_order, this.route_payment_paypal)
          if (response.success) {
            this.$store.dispatch('cleanCart')
            localStorage.removeItem('campaign_order')
            this.$store.dispatch('setPackageOrder', null)

            if (this.campaign_order && this.campaign_order.date == this.now) {
              this.$router.push('/confirmacion-compra?dcn=s')
            } else {
              this.$router.push('/confirmacion-compra')
              //this.success_payment = true
            }
          } else {
            this.$swal(response.message, '', 'warning')
          }
          this.loading = false
        }).catch(res => {
          this.$swal("Estamos teniendo problemas al ejecutar el pago con PayPal", "Intenta más tarde", "warning");
        });
      }
    }, '#paypal-button');
  },
  destroyed() {
    this.$store.state.step_payment_order = ''
    this.$store.dispatch('setTotalCart', this.cart_total)
    this.$store.dispatch('selectDiscount', { discount: null, amount_discount: 0 })
  }
}
</script>

<style scoped>
>>>.v-radio .v-label {
  margin: 0 !important
}
>>>.vbga-results {
	background-color: #14365b;
	color: #ffffff;
	list-style: none;
	padding-left: 0;
  z-index: 1000000 !important;
  font-family: var(--font-baloo-regular);
  border-radius: 10px;
  position: relative
}
>>>.vbga-results li {
	padding: 5px;
}
>>>.vbga-results li:hover {
	cursor: pointer;
	background-color: #ed717c;
}
>>>.v-input--selection-controls {
  padding-top: 0;
}
>>>.v-input__control {
  flex-direction: unset;
  flex-wrap: unset
}
>>>.v-input__slot {
  margin-bottom: 0 !important;
}
>>>.v-input--selection-controls {
  margin-top: 5px
}
>>>.v-dialog {
  box-shadow: none;
}
.pa-sm-4 {
  padding: 0 !important;
}
@media only screen and (min-width: 1500px) and (max-width: 2000px) {
  .input-nv .input-nv-padding {
    padding: 30px !important
  }
  .pa-sm-4 {
    padding: 0 !important
  }
  >>>.vbga-results {
    font-size: 18px
  }
}
@media only screen and (min-width: 2080px) and (max-width: 3000px) {
  .input-nv .input-nv-padding {
    padding: 30px !important
  }
  .pa-sm-4 {
    padding: 5px !important
  }
  >>>.vbga-results {
    font-size: 22px
  }
}
</style>
